export default __webpack_public_path__ + "static/media/message.600af9aa.svg";